module.exports = __webpack_public_path__ + "static/media/mengduoxiaochengxu.31c79b6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduoxiaochengxu.jpg
// module id = 127
// module chunks = 6